import axios from 'axios';

import { replaceWeeglooCdnUrl } from './utils';

const WEEGLOO_SPACE_ID = process.env.NEXT_PUBLIC_WEEGLOO_SPACE_ID;
const WEEGLOO_CDN_TOKEN = process.env.NEXT_PUBLIC_WEEGLOO_CDN_TOKEN;

/**
 * Zepetoful axios 인스턴스 설정 생성
 * @param locale - locale (기본값: en-US)
 */
export const createZepetofulAxiosConfig = (locale = 'en-US') => ({
  baseURL: `https://zep.us/weegloo/cda/v1/spaces/${WEEGLOO_SPACE_ID}/contents`,
  headers: {
    Authorization: `Bearer ${WEEGLOO_CDN_TOKEN}`,
  },
  params: {
    locale: locale === 'en' ? 'en-US' : locale,
    select:
      process.env.NEXT_PUBLIC_STAGE === 'PRD'
        ? 'fields.json'
        : 'fields.jsonDev',
  },
});

/**
 * Weegloo CDA 클라이언트 생성 (읽기 전용)
 * @description Content Delivery API - 퍼블리시된 콘텐츠 조회용
 * @param locale - locale (기본값: en-US)
 */
export const createZepetofulClient = (locale = 'en-US') => {
  const client = axios.create(createZepetofulAxiosConfig(locale));
  client.interceptors.response.use(response => {
    const fields = response.data?.fields;
    if (typeof fields !== 'object') {
      return response;
    }
    const jsonData = fields.json ?? fields.jsonDev;
    response.data = replaceWeeglooCdnUrl(jsonData);
    return response;
  });
  return client;
};
